// @flow
import type { Action } from '../actions/types';
import {
	UPDATE_APP,
	TRIGGER_UPDATE_APP,
	HIDE_INSTALL_BANNER,
	APP_INSTALLED,
	SHOW_INSTALL_PROMPT,
	HIDE_INSTALL_PROMPT,
	TRIGGER_INSTALL,
} from '../actions/types';
import { getCookie } from '../utils';

export type ServiceWorkerState = {|
	updatedApp: boolean,
	triggeredUpdateApp: boolean,
	hideInstallBanner: boolean,
	appInstalled: boolean,
	promptEvent: any | null,
	triggerInstall: boolean,
|};

const hideInstallBanner = getCookie('hideInstallBanner');
const initialState: ServiceWorkerState = {
	updatedApp: false,
	triggeredUpdateApp: false,
	hideInstallBanner: !!+hideInstallBanner || false,
	appInstalled: true,
	promptEvent: null,
	triggerInstall: false,
};

export const serviceWorkerReducer = (state: ServiceWorkerState = initialState, action: Action): ServiceWorkerState => {
	const { type } = action;
	switch (type) {
		case TRIGGER_UPDATE_APP:
			return {
				...state,
				triggeredUpdateApp: true,
				updatedApp: false,
			};

		case UPDATE_APP:
			return {
				...state,
				updatedApp: true,
			};

		case HIDE_INSTALL_BANNER:
			return {
				...state,
				hideInstallBanner: true,
			};

		case SHOW_INSTALL_PROMPT:
		{
			const { triggerInstall, appInstalled } = state;
			return {
				...state,
				appInstalled: triggerInstall && appInstalled, 
				promptEvent: action.payload,
			};
		}

		case APP_INSTALLED:
			return {
				...state,
				appInstalled: true,
				promptEvent: null,
			};

		case HIDE_INSTALL_PROMPT:
			return {
				...state,
				promptEvent: null,
			};

		case TRIGGER_INSTALL:
		 return {
			 ...state,
			 hideInstallBanner: true,
			 promptEvent: true,
			 triggerInstall: true,
		 }
		default:
			return state;
	}
};
